import type { TranslationDictionary } from "../types";

const fr: TranslationDictionary = {
  // ── Nav ──────────────────────────────────────────────────────────────
  "nav.properties": "Biens",
  "nav.outreach": "Prospection",
  "nav.settings": "Paramètres",
  "nav.toggleTheme": "Changer le thème",
  "nav.dashboard": "Tableau de bord",
  "nav.taches": "Tâches",
  "nav.valides": "Validés",
  "nav.archives": "Archives",
  "nav.aArbitrer": "À arbitrer",
  "nav.mesSms": "Mes SMS",

  // ── Mes SMS (Feature #6 : personnalisation par commercial) ───────────
  "mesSms.title": "Mes SMS automatiques",
  "mesSms.subtitle": "Personnalise les 2 messages envoyés en premier contact. Le système alterne entre les deux à chaque envoi (diversité anti-spam).",
  "mesSms.captationLabel": "Message n°1 — Captation",
  "mesSms.captationDescription": "Style direct : on présente la proposition (captation pour associations).",
  "mesSms.accrocheLabel": "Message n°2 — Accroche",
  "mesSms.accrocheDescription": "Style question ouverte : on interpelle sur l'annonce du vendeur.",
  "mesSms.placeholderHint": "Placeholder disponible :",
  "mesSms.placeholderExplain": "sera remplacé automatiquement par ton prénom au moment de l'envoi.",
  "mesSms.limitHint": "Idéalement ≤ {count} caractères : au-delà, le SMS peut être découpé en plusieurs segments et arriver dans le désordre.",
  "mesSms.chars": "caractères",
  "mesSms.warnSplit": "risque de découpe SMS",
  "mesSms.warnMax": "maximum {max} atteint",
  "mesSms.badgeCustom": "Version personnalisée",
  "mesSms.badgeDefault": "Version par défaut",
  "mesSms.resetDefault": "Réinitialiser",
  "mesSms.save": "Enregistrer",
  "mesSms.saving": "Enregistrement...",
  "mesSms.saved": "Templates enregistrés",
  "mesSms.saveFailed": "Échec de l'enregistrement",

  // ── Dashboard ────────────────────────────────────────────────────────
  "dashboard.title": "Tableau de bord",
  "dashboard.subtitle": "Vue d'ensemble du pipeline immobilier",
  "dashboard.properties": "Biens",
  "dashboard.listings": "Annonces",
  "dashboard.withPhone": "Avec tél.",
  "dashboard.new24h": "Nouveau (24h)",
  "dashboard.new7d": "Nouveau (7j)",
  "dashboard.needsReview": "À vérifier",
  "dashboard.scheduler": "Planificateur",
  "dashboard.outreach": "Prospection",
  "dashboard.pipeline": "Pipeline",
  "dashboard.active": "{count} en cours",
  "dashboard.idle": "Inactif",
  "dashboard.lastRun": "Dernière exéc.",
  "dashboard.on": "Actif",
  "dashboard.off": "Inactif",
  "dashboard.recentRuns": "Exécutions récentes",
  "dashboard.pipelineRun": "Exécution pipeline",
  "dashboard.found": "trouvées",
  "dashboard.new": "nouvelles",
  "dashboard.noRuns": "Aucune exécution",
  "dashboard.viewAllRuns": "Voir toutes les exécutions →",
  "dashboard.dbError": "Impossible de se connecter à la base de données. Vérifiez votre connexion et rafraîchissez la page.",
  "dashboard.next": "prochaine {time}",

  // ── Charts ───────────────────────────────────────────────────────────
  "chart.costBreakdown": "Ventilation des coûts (30j)",
  "chart.noCostData": "Aucune donnée de coût enregistrée.",
  "chart.sourceBreakdown": "Répartition par source",
  "chart.outreachFunnel": "Entonnoir de prospection",
  "chart.matchingDistribution": "Distribution des correspondances",
  "cost.apify": "Apify",
  "cost.openai": "OpenAI",
  "cost.sms": "SMS",
  "cost.playwright": "Playwright",

  // ── Properties ───────────────────────────────────────────────────────
  "properties.title": "Biens",
  "properties.allProperties": "Tous les biens",
  "properties.unmatched": "Non associées",
  "properties.falseNegatives": "Faux négatifs",
  "properties.pipeline": "Pipeline",
  "properties.overview": "Vue d'ensemble",
  "properties.sources": "Sources",
  "properties.total": "Total",
  "properties.pending": "Nouveau",
  "properties.contacted": "Contacté",
  "properties.withPhone": "Avec tél.",
  "properties.noPhone": "Sans tél.",
  "properties.needsReview": "À vérifier",

  // ── Properties Board ─────────────────────────────────────────────────
  "board.searchPlaceholder": "Rechercher titre, ville, code postal, tél...",
  "board.allStatuses": "Tous les statuts",
  "board.allSources": "Toutes les sources",
  "board.allDepartments": "Tous les départements",
  "board.department": "Département",
  "board.all": "Tous",
  "board.withPhone": "Avec tél. ({count})",
  "board.noPhone": "Sans tél. ({count})",
  "board.needsReview": "À vérifier ({count})",
  "board.noProperties": "Aucun bien trouvé.",
  "board.noLinkedListings": "Aucune annonce liée.",
  "board.loading": "Chargement...",
  "board.title": "Titre",
  "board.price": "Prix",
  "board.surface": "Surface",
  "board.rooms": "Pièces",
  "board.city": "Ville",
  "board.phone": "Téléphone",
  "board.outreach": "Prospection",
  "board.lastSeen": "Vu le",
  "board.sortByListings": "Trier par annonces",
  "board.delete": "Supprimer {count}",
  "board.deleteConfirm": "Supprimer {count} {noun} ? Cette action est irréversible.",
  "board.deleted": "{count} {noun} supprimé(s)",
  "board.archive": "Archiver {count}",
  "board.archiveConfirm": "Archiver {count} {noun} ? Ces biens ne seront plus proposés en prospection mais resteront visibles dans les archives.",
  "board.archived": "{count} {noun} archivé(s)",
  "board.anyAge": "Toute ancienneté",
  "board.olderThan7Days": "Plus de 7 jours",
  "board.olderThan15Days": "Plus de 15 jours",
  "board.olderThan30Days": "Plus de 30 jours",
  "board.olderThan60Days": "Plus de 60 jours",
  "board.propertyOne": "bien",
  "board.propertyMany": "biens",
  "board.propertiesCount": "{count} {noun}",
  "board.page": "Page {page} sur {totalPages} ({total} au total)",
  "board.previous": "Précédent",
  "board.next": "Suivant",
  "board.untitled": "Sans titre",
  "board.status": "Statut",

  // ── Property statuses (PropertyStatus enum) ───────────────────────────
  "status.pending": "Nouveau",
  "status.manual_pending": "En attente de traitement manuel",
  "status.manual_phone_fixe": "Numéro fixe - à appeler",
  "status.contacted": "Contacté",
  "status.followup_1": "Relance 1",
  "status.followup_2": "Relance 2",
  "status.positive_return": "À appeler",
  "status.validated": "Validé",
  "status.archived": "Archivé",
  "status.blacklisted": "Blacklisté",

  // ── Archive reasons ───────────────────────────────────────────────────
  "archiveReason.negative_return": "Retour négatif",
  "archiveReason.inactivity": "Inactivité",
  "archiveReason.manual": "Manuel",

  // ── Outreach / Interaction statuses ──────────────────────────────────
  "status.responded": "répondu",
  "status.rejected": "refusé",
  "status.closed": "clôturé",
  "status.sent": "envoyé",
  "status.failed": "échoué",
  "status.noResponse": "sans réponse",
  "status.qualified": "qualifié",
  "status.manualRequired": "Action requise",
  "status.pendingSend": "En attente",
  "status.interested": "Intéressé",
  "status.notInterested": "Pas intéressé",
  "status.pendingReview": "À valider",
  "status.running": "en cours",
  "status.completed": "terminé",
  "status.cancelled": "annulé",

  // ── Commercial Dashboard ──────────────────────────────────────────────
  "commercial.dashboardTitle": "Tableau de bord commercial",
  "commercial.lastWeek": "7 derniers jours",
  "commercial.lastMonth": "30 derniers jours",
  "commercial.week": "Semaine",
  "commercial.month": "Mois",
  "commercial.sectionActivity": "Activité",
  "commercial.sectionOutcomes": "Résultats",
  "commercial.sectionCurrent": "État actuel",
  "commercial.scraped": "Scrapés",
  "commercial.smsSent": "SMS envoyés",
  "commercial.followupSent": "Relances",
  "commercial.transformationRate": "Taux de transformation",
  "commercial.positiveReturns": "Retours positifs",
  "commercial.negativeReturns": "Retours négatifs",
  "commercial.validated": "Validés",
  "commercial.activePipeline": "Pipeline actif",
  "commercial.manualPending": "Envois manuels",
  "commercial.fnPending": "Doublons à vérifier",

  // ── Property Detail ──────────────────────────────────────────────────
  "detail.backToProperties": "Retour aux biens",
  "detail.needsReview": "À vérifier",
  "detail.price": "Prix",
  "detail.surface": "Surface",
  "detail.rooms": "Pièces",
  "detail.bedrooms": "Chambres",
  "detail.city": "Ville",
  "detail.postalCode": "Code postal",
  "detail.gps": "GPS",
  "detail.phone": "Téléphone",
  "detail.firstSeen": "Première vue",
  "detail.lastSeen": "Dernière vue",
  "detail.photosMatching": "{count} photo{s} correspondante(s) entre annonces",
  "detail.relatedByPhone.title": "Ce numéro est aussi lié à {count} autre{s} bien{s}",
  "detail.relatedByPhone.subtitle": "Il s'agit probablement du même contact (agence, bailleur multi-biens). Pour éviter le démarchage abusif, un seul bien par numéro est contacté automatiquement.",
  "detail.relatedByPhone.tag.duplicate": "Archivé (doublon tél.)",
  "detail.relatedByPhone.noCity": "Sans ville",
  "detail.linkedListings": "Annonces liées ({count})",
  "detail.noLinkedListings": "Aucune annonce liée.",
  "detail.original": "Original",
  "detail.photoMatch": "Correspondance photo",
  "detail.partialPhoto": "Photo partielle",
  "detail.criteriaOnly": "Critères uniquement",
  "detail.manual": "Manuel",
  "detail.photosMatch": "{count} photo{s} correspondante(s)",
  "detail.review": "À vérifier",
  "detail.manuallyConfirmed": "Confirmé manuellement",
  "detail.manualSeparation": "Séparation manuelle",
  "detail.confirm": "Confirmer",
  "detail.reject": "Rejeter",
  "detail.hashes": "Hashes ({count}) :",
  "detail.none": "aucun",
  "detail.scraped": "Scrapé",
  "detail.photos": "{count} photo{s}",
  "detail.outreach": "Prospection ({count})",
  "detail.reason": "Raison",
  "detail.model": "Modèle",
  "detail.prompt": "Prompt",

  // ── Interaction channels ─────────────────────────────────────────────
  "channel.sms": "SMS",
  "channel.formPap": "Formulaire PAP",
  "channel.formSeloger": "Formulaire SeLoger",
  "channel.formLogicimmo": "Formulaire Logic-Immo",
  "channel.formBienici": "Formulaire Bien Ici",
  "channel.formLefigaro": "Formulaire LeFigaro",
  "channel.manual": "Manuel",

  // ── Unmatched ────────────────────────────────────────────────────────
  "unmatched.source": "Source",
  "unmatched.title": "Titre",
  "unmatched.price": "Prix",
  "unmatched.surface": "Surface",
  "unmatched.rooms": "Pièces",
  "unmatched.city": "Ville",
  "unmatched.phone": "Téléphone",
  "unmatched.property": "Bien",
  "unmatched.scraped": "Scrapé",
  "unmatched.yes": "Oui",
  "unmatched.noListings": "Aucune annonce trouvée.",
  "unmatched.listingCount": "{count} annonce{s}",
  "unmatched.deleteSelected": "Supprimer {count} sélectionnée(s)",
  "unmatched.deleteConfirm": "Supprimer {count} annonce{s} ? Cette action est irréversible.",
  "unmatched.deleted": "{count} annonce{s} supprimée(s)",
  "unmatched.page": "Page {page} sur {totalPages}",
  "unmatched.previous": "Précédent",
  "unmatched.next": "Suivant",

  // ── False Negatives ──────────────────────────────────────────────────
  "fn.title": "Vérification des faux négatifs",
  "fn.subtitle": "Trouver les paires de biens qui devraient être fusionnées mais qui ont été manquées par le matcher.",
  "fn.scan": "Scanner",
  "fn.scanning": "Scan en cours…",
  "fn.propertiesScanned": "{count} biens scannés",
  "fn.pairsEvaluated": "{count} paires évaluées",
  "fn.candidates": "{count} candidats",
  "fn.noCandidates": "Aucun candidat faux négatif trouvé. Tous les biens semblent correctement séparés.",
  "fn.reviewing": "Vérification {current} sur {total}",
  "fn.merged": "{count} fusionné(s)",
  "fn.rejected": "{count} rejeté(s)",
  "fn.skipped": "{count} ignoré(s)",
  "fn.reviewComplete": "Vérification terminée",
  "fn.candidatesReviewed": "{count} candidat{s} vérifié(s)",
  "fn.scanAgain": "Rescanner",
  "fn.skip": "Ignorer",
  "fn.merge": "Fusionner",
  "fn.moreDetails": "Plus de détails",
  "fn.less": "Moins",
  "fn.untitledProperty": "Bien sans titre",
  "fn.listing": "{count} annonce{s}",
  "fn.seen": "Vu {from} → {to}",
  "fn.noPhotos": "Pas de photos",
  "fn.mergeSuccess": "Fusionné : {count} annonce(s) déplacée(s)",
  "fn.rejectSuccess": "Rejeté — ne s'affichera plus",

  // ── Outreach Hub ─────────────────────────────────────────────────────
  "outreach.title": "Prospection",
  "outreach.automated": "Automatisé",
  "outreach.outreachPipeline": "Pipeline de prospection",
  "outreach.total": "{count} au total",
  "outreach.failed": "{count} échoué(s)",
  "outreach.noResponse": "{count} sans réponse",
  "outreach.copyMessage": "Copier le message",
  "outreach.copied": "Copié",
  "outreach.messageCopied": "Message copié dans le presse-papiers",
  "outreach.markAsSent": "Marquer comme envoyé",
  "outreach.markedAsSent": "Marqué comme envoyé",
  "outreach.failedUpdate": "Échec de la mise à jour",
  "outreach.viewProperty": "Voir le bien",
  "outreach.untitledProperty": "Bien sans titre",
  "outreach.room": "{count} pièce{s}",
  "outreach.interactions": "Interactions",
  "outreach.notInterested": "{count} pas intéressé(s)",
  "outreach.recordResponse": "Enregistrer la réponse",
  "outreach.responsePlaceholder": "Saisir la réponse reçue...",
  "outreach.submitResponse": "Envoyer",
  "outreach.responseRecorded": "Réponse enregistrée",
  "outreach.failedRecordResponse": "Échec de l'enregistrement",
  "outreach.retryAsManual": "Relancer en manuel",
  "outreach.retriedAsManual": "Déplacé vers la file manuelle",
  "outreach.failureReason": "Raison de l'échec",
  "outreach.failureReason.listing_unavailable": "Annonce indisponible",
  "outreach.failureReason.apify_empty_dataset": "Aucune annonce trouvée lors de la recherche",
  "outreach.failureReason.apify_run_failed": "La recherche d'annonces a échoué",
  "outreach.failureReason.apify_run_timed_out": "La recherche d'annonces a pris trop de temps",
  "outreach.failureReason.apify_run_aborted": "La recherche d'annonces a été interrompue",
  "outreach.failureReason.apify_form_failed": "Le formulaire de contact n'a pas pu être envoyé",
  "outreach.failureReason.missing_listing_url": "Lien vers l'annonce introuvable",
  "outreach.failureReason.missing_form_context": "Informations insuffisantes pour contacter le propriétaire",
  "outreach.failureReason.make_scenario_did_not_complete": "L'envoi du message n'a pas abouti",
  "outreach.failureReason.numero_fixe": "Numéro fixe — impossible d'envoyer un SMS",
  "outreach.failureReason.landline_number": "Numéro fixe — impossible d'envoyer un SMS",
  "outreach.failureReason.sms_not_sent": "Le SMS n'a pas pu être envoyé",
  "outreach.failureReason.manual_fallback": "Échec de l'envoi automatique — à traiter manuellement",
  "outreach.failureReason.manual_fallback.form_seloger": "Le formulaire SeLoger a échoué — à traiter manuellement",
  "outreach.failureReason.manual_fallback.form_pap": "Le formulaire PAP a échoué — à traiter manuellement",
  "outreach.failureReason.manual_fallback.sms": "L'envoi du SMS a échoué — à traiter manuellement",
  "outreach.failureReason.generic": "L'envoi a échoué — veuillez réessayer ou contacter un administrateur",
  "outreach.failureReason.no_automated_channel_available": "Aucun canal automatique disponible. Saisissez un numéro et cliquez sur « Relancer en SMS », ou copiez le message et collez-le sur la plateforme pour contacter le propriétaire manuellement.",
  "outreach.failureReason.no automated channel available": "Aucun canal automatique disponible. Saisissez un numéro et cliquez sur « Relancer en SMS », ou copiez le message et collez-le sur la plateforme pour contacter le propriétaire manuellement.",
  "outreach.smsSending": "SMS en cours d'envoi",
  "outreach.sendFailed": "Erreur lors de l'envoi",
  "outreach.networkError": "Erreur réseau",
  "outreach.copyFailed": "Impossible de copier le message",
  "outreach.enterPhone": "Entrez un numéro de téléphone",
  "outreach.relaunchSms": "Relancer en SMS",
  "outreach.openListing": "Ouvrir sur {source}",
  "outreach.pasteHint": "à coller dans la messagerie {source}",
  "outreach.markingSent": "Enregistrement…",
  "outreach.foundPhone": "J'ai trouvé un numéro",
  "outreach.stale3d": "3j sans réponse",
  "outreach.stale5d": "5j+ sans réponse",
  "outreach.outgoingMessage": "Message envoyé",
  "outreach.response": "Réponse",
  "outreach.confidence": "Confiance",
  "outreach.classification": "Classification",
  "outreach.regenerateMessage": "Regénérer",
  "outreach.regenerating": "Regénération...",
  "outreach.messageRegenerated": "Message regénéré",
  "outreach.failedRegenerate": "Échec de la regénération du message",
  "outreach.regenerateAll": "Tout regénérer",
  "outreach.regeneratingAll": "Regénération en cours...",
  "outreach.allRegenerated": "Messages regénérés ({count})",
  "outreach.regenerateQueued": "Regénération en file — les messages seront mis à jour sous peu",
  "outreach.viewPrompt": "Voir le prompt",
  "outreach.testBadge": "Test",
  "outreach.testBadgeDetail": "Mode Test",

  // ── Outreach Auto ────────────────────────────────────────────────────
  "outreachAuto.searchPlaceholder": "Rechercher un bien...",
  "outreachAuto.allChannels": "Tous les canaux",
  "outreachAuto.allStatuses": "Tous les statuts",
  "outreachAuto.interactionCount": "{count} interaction{s}",
  "outreachAuto.propertyCol": "Bien",
  "outreachAuto.phoneCol": "Téléphone",
  "outreachAuto.channelCol": "Canal",
  "outreachAuto.statusCol": "Statut",
  "outreachAuto.dateCol": "Date",
  "outreachAuto.noInteractions": "Aucune interaction automatisée trouvée",
  "outreachAuto.noMessageContent": "Aucun contenu de message.",
  "outreachAuto.page": "Page {page} sur {totalPages} ({total} au total)",
  "outreachAuto.previous": "Précédent",
  "outreachAuto.next": "Suivant",
  "outreachAuto.messageCopied": "Message copié",
  "outreachAuto.sent": "Envoyé",

  // ── Settings ─────────────────────────────────────────────────────────
  "settings.title": "Paramètres",
  "settings.runs": "Exécutions",
  "settings.scraping": "Scraping",
  "settings.prospection": "Prospection",
  "settings.arguments": "Arguments",
  "settings.blacklist": "Blacklist",
  "settings.language": "Langue",

  // ── Run Controls ─────────────────────────────────────────────────────
  "runControls.scraping": "Scraping :",
  "runControls.prospection": "Prospection :",
  "runControls.active": "Actif",
  "runControls.disabled": "Désactivé",
  "runControls.lastRun": "Dernière exéc. :",
  "runControls.nextRun": "Prochaine exéc. :",
  "runControls.sources": "{enabled}/{total} sources",
  "runControls.flagTestMode": "Mode test actif",
  "runControls.flagFailedRuns": "{count} run{s} échoué{s} (24h)",
  "runControls.flagNoSources": "Aucune source active",

  // ── Runs Table ───────────────────────────────────────────────────────
  "runs.all": "Tous",
  "runs.status": "Statut",
  "runs.task": "Tâche",
  "runs.source": "Source",
  "runs.started": "Démarré",
  "runs.duration": "Durée",
  "runs.found": "Trouvées",
  "runs.new": "Nouvelles",
  "runs.noRuns": "Aucune exécution trouvée.",
  "runs.runCount": "{count} exécution{s}",
  "runs.page": "Page {page} sur {totalPages}",
  "runs.previous": "Précédent",
  "runs.next": "Suivant",
  "runs.pipelineSteps": "Étapes du pipeline :",
  "runs.error": "Erreur : ",
  "runs.errors": "Erreurs : ",
  "runs.result": "Résultat : ",
  "runs.payload": "Payload : ",
  "runs.refetchDataset": "Re-télécharger",
  "runs.refetching": "Téléchargement...",
  "runs.cancel": "Annuler",
  "runs.cancelling": "Annulation...",
  "runs.runCancelled": "Exécution annulée",

  // ── Runs Page Client ─────────────────────────────────────────────────
  "runsPage.matchUnmatched": "Matcher les annonces non associées",
  "runsPage.moreActions": "Plus d'actions",
  "runsPage.hashMissing": "Hasher les photos manquantes",
  "runsPage.recalculateHashes": "Recalculer tous les hashes",
  "runsPage.enrichUnenriched": "Enrichir les annonces non enrichies",
  "runsPage.matchJobQueued": "Job de matching lancé (exéc. {id}...)",
  "runsPage.failedQueueMatch": "Échec du lancement du matching",
  "runsPage.noListingsToHash": "Aucune annonce à hasher",
  "runsPage.hashJobQueued": "{count} annonce{s} en file pour le hashing",
  "runsPage.failedQueueHash": "Échec du lancement du hashing",
  "runsPage.enrichJobQueued": "Job d'enrichissement lancé (exéc. {id}...)",
  "runsPage.failedQueueEnrich": "Échec du lancement de l'enrichissement",

  // ── Schedule Config ──────────────────────────────────────────────────
  "scheduleConfig.title": "Planification",
  "scheduleConfig.enableAutomatic": "Activer la planification automatique",
  "scheduleConfig.startHour": "Heure de départ",
  "scheduleConfig.runEvery": "Exécuter toutes les",
  "scheduleConfig.hours": "{count} heure{s}",
  "scheduleConfig.lastRun": "Dernière exéc. : ",
  "scheduleConfig.nextRun": "Prochaine exéc. : ",
  "scheduleConfig.never": "Jamais",
  "scheduleConfig.notScheduled": "Non planifié",
  "scheduleConfig.save": "Enregistrer",
  "scheduleConfig.saving": "Enregistrement...",
  "scheduleConfig.runNow": "Lancer",
  "scheduleConfig.triggering": "Lancement...",
  "scheduleConfig.scheduleSaved": "Planification enregistrée",
  "scheduleConfig.triggered": "{count} exécution(s) du pipeline lancée(s)",

  // ── Source Config ────────────────────────────────────────────────────
  "sourceConfig.title": "Configuration des sources",
  "sourceConfig.addSource": "Ajouter une source",
  "sourceConfig.cancel": "Annuler",
  "sourceConfig.source": "Source",
  "sourceConfig.maxPages": "Pages max",
  "sourceConfig.searchUrl": "URL de recherche",
  "sourceConfig.enabled": "Activé",
  "sourceConfig.create": "Créer",
  "sourceConfig.save": "Enregistrer",
  "sourceConfig.noConfigs": "Aucune configuration de source. Ajoutez-en une pour commencer.",
  "sourceConfig.deleteTitle": "Supprimer la configuration ?",
  "sourceConfig.deleteDescription": "Cette action supprimera définitivement la configuration {source}. Cette action est irréversible.",
  "sourceConfig.delete": "Supprimer",
  "sourceConfig.pageCount": "{count} page{s}",
  "sourceConfig.unassigned": "Non assigné",
  "sourceConfig.noSourcesForUser": "Aucune source configurée",
  "sourceConfig.department": "Département",
  "sourceConfig.user": "Utilisateur",

  // ── Outreach Config ──────────────────────────────────────────────────
  "outreachConfig.title": "Prospection",
  "outreachConfig.enableAutomatic": "Activer la prospection automatique",
  "outreachConfig.schedule": "Planification",
  "outreachConfig.startHour": "Heure de début",
  "outreachConfig.every": "Toutes les",
  "outreachConfig.hours": "{count} heure{s}",
  "outreachConfig.defaultPromptLabel": "Prompt par défaut :",
  "outreachConfig.userMessageLabel": "Données transmises :",
  "outreachConfig.argumentsLabel": "{count} argument{s} actif{s} — 2 sélectionnés par run :",
  "outreachConfig.promptInstruction": "Instructions pour le prompt",
  "outreachConfig.promptHelp": "Ajouté au prompt de base lors de la génération des messages de prospection.",
  "outreachConfig.senderProfile": "Profil de l'expéditeur",
  "outreachConfig.firstName": "Prénom",
  "outreachConfig.lastName": "Nom",
  "outreachConfig.email": "E-mail",
  "outreachConfig.phone": "Téléphone",
  "outreachConfig.lastRun": "Dernière exéc. : ",
  "outreachConfig.nextRun": "Prochaine exéc. : ",
  "outreachConfig.never": "Jamais",
  "outreachConfig.notScheduled": "Non planifié",
  "outreachConfig.save": "Enregistrer",
  "outreachConfig.saving": "Enregistrement...",
  "outreachConfig.runNow": "Lancer",
  "outreachConfig.triggering": "Lancement...",
  "outreachConfig.saved": "Configuration de prospection enregistrée",
  "outreachConfig.triggered": "Routage de prospection lancé",
  "outreachConfig.failedTrigger": "Échec du lancement",
  "outreachConfig.enableHook": "Activer le message d'accroche (Étape 1)",
  "outreachConfig.hookMessage": "Prompt hook SMS",
  "outreachConfig.hookMessageHelp": "Prompt utilisé pour générer le 1er SMS (toutes sources). Si vide, le prompt hook par défaut est utilisé.",
  "outreachConfig.hookMessagePlaceholder": "Rôle : Copywriter SMS...\nMission : Rédiger un SMS ultra-court...\nContraintes : 2 phrases max...",
  "outreachConfig.enableFollowup": "Activer les relances automatiques",
  "outreachConfig.followupPromptInstruction": "Prompt de relance 1",
  "outreachConfig.followupPromptHelp": "Instructions pour générer le message de relance. Laissez vide pour utiliser le prompt par défaut.",
  "outreachConfig.followup1Delay": "Délai relance 1 :",
  "outreachConfig.days": "jours",
  "outreachConfig.enableFollowup2": "Activer la 2ème relance",
  "outreachConfig.followup2Delay": "Délai relance 2 :",
  "outreachConfig.followup2PromptInstruction": "Prompt de relance 2",
  "outreachConfig.followup2PromptHelp": "Instructions pour la 2ème relance. Si vide, le prompt de relance 1 est utilisé.",
  "outreachConfig.enableTestMode": "Activer le mode test",
  "outreachConfig.testPhone": "Téléphone de test",
  "outreachConfig.testPhoneHelp": "En mode test, les SMS sont envoyés à ce numéro (1 par minute par canal). Les interactions de test sont supprimées à la désactivation du mode test.",
  "outreachConfig.formChannels": "Canaux formulaire",
  "outreachConfig.enableFormSeloger": "Activer le formulaire SeLoger",
  "outreachConfig.enableFormPap": "Activer le formulaire PAP",
  "outreachConfig.formTestContact": "Coordonnées formulaire de test",
  "outreachConfig.formTestHelp": "Si vides, les formulaires sont ignorés en mode test (seuls les SMS sont envoyés).",
  "outreachConfig.formTestFirstName": "Prénom",
  "outreachConfig.formTestLastName": "Nom",
  "outreachConfig.formTestEmail": "E-mail",
  "outreachConfig.formTestPhone": "Téléphone",

  // ── Listing Modal ────────────────────────────────────────────────────
  "listingModal.untitled": "Annonce sans titre",
  "listingModal.viewOriginal": "Voir l'annonce originale",
  "listingModal.description": "Description",
  "listingModal.enrichedData": "Données enrichies",
  "listingModal.hashes": "Hashes ({count})",
  "listingModal.recalculate": "Recalculer",
  "listingModal.queuing": "Mise en file...",
  "listingModal.noHashes": "Aucun hash calculé.",
  "listingModal.details": "Détails",
  "listingModal.scraped": "Scrapé",
  "listingModal.created": "Créé",
  "listingModal.updated": "Mis à jour",
  "listingModal.sourceId": "ID source",
  "listingModal.internalId": "ID interne",
  "listingModal.fieldProvenance": "Provenance des champs",
  "listingModal.linkedProperty": "Bien lié",
  "listingModal.photos": "{count} photo{s}",
  "listingModal.room": "Pièce",
  "listingModal.rooms": "Pièces",
  "listingModal.bedroom": "Chambre",
  "listingModal.bedrooms": "Chambres",
  "listingModal.price": "Prix",
  "listingModal.pricePerM2": "{price}/m²",
  "listingModal.rehashQueued": "En file — les hashes seront mis à jour sous peu",

  // ── Language ─────────────────────────────────────────────────────────
  "language.title": "Langue",
  "language.description": "Choisissez la langue d'affichage de l'application.",
  "language.french": "Français",
  "language.english": "English",

  // ── Enriched field labels ────────────────────────────────────────────
  "enriched.floor": "Étage",
  "enriched.nb_floors": "Nombre d'étages",
  "enriched.bedrooms": "Chambres (IA)",
  "enriched.surface": "Surface (IA)",
  "enriched.surface_carrez": "Surface Carrez",

  // ── Provenance badges ────────────────────────────────────────────────
  "provenance.geocoded": "Géocodé",
  "provenance.ai": "IA",
  "provenance.scraped": "Scrapé",
  "provenance.computed": "Calculé",

  // ── Time ago ─────────────────────────────────────────────────────────
  "time.secondsAgo": "il y a {count}s",
  "time.minutesAgo": "il y a {count}min",
  "time.hoursAgo": "il y a {count}h",
  "time.daysAgo": "il y a {count}j",
  "time.today": "aujourd'hui",

  // ── FN detail columns ────────────────────────────────────────────────
  "fnDetail.bedrooms": "Chambres",
  "fnDetail.gps": "GPS",
  "fnDetail.firstLastSeen": "Première / Dernière vue",
  "fnDetail.description": "Description",

  // ── Login ────────────────────────────────────────────────────────────
  "login.subtitle": "Connectez-vous à votre compte",
  "login.password": "Mot de passe",
  "login.submit": "Se connecter",
  "login.submitting": "Connexion…",
  "login.invalidCredentials": "Identifiants invalides",
  "login.networkError": "Erreur réseau, veuillez réessayer.",

  // ── Nav extras ───────────────────────────────────────────────────────
  "nav.home": "Accueil",
  "nav.team": "Équipe",
  "nav.logout": "Déconnexion",

  // ── Tasks (taches) ───────────────────────────────────────────────────
  "taches.title": "Tâches",
  "taches.manualSend": "Envoi manuel",
  "taches.duplicateCandidate": "Doublon potentiel",
  "taches.matchToReview": "Correspondance à vérifier",
  "taches.markedSent": "Marqué comme envoyé",
  "taches.sendFailed": "Échec de l'envoi",
  "taches.regenerateFailed": "Échec de la regénération",
  "taches.messageRegenerated": "Message regénéré",
  "taches.messageCopied": "Message copié",
  "taches.taskCancelled": "Tâche annulée",
  "taches.cancelFailed": "Échec de l'annulation",
  "taches.untitledProperty": "Bien sans titre",
  "taches.foundOn": "Découvert le ",
  "taches.seenOn": "Vu le ",
  "taches.propertyDetails": "Détails du bien",
  "taches.viewProperty": "Voir le bien",
  "taches.message": "Message",
  "taches.regenerating": "Regénération...",
  "taches.regenerate": "Regénérer",
  "taches.copied": "Copié",
  "taches.copy": "Copier",
  "taches.messagePlaceholder": "Message à envoyer...",
  "taches.skip": "Passer",
  "taches.cancelling": "Annulation...",
  "taches.listingUnavailable": "Annonce indisponible",
  "taches.sending": "Envoi en cours...",
  "taches.markAsSent": "Marquer comme envoyé",
  "taches.merged": "Fusionné",
  "taches.rejected": "Rejeté",
  "taches.actionFailed": "Échec de l'action",
  "taches.highConfidence": "Confiance élevée",
  "taches.mediumConfidence": "Confiance moyenne",
  "taches.lowConfidence": "Confiance faible",
  "taches.samePhone": "Tél. identique",
  "taches.differentPhone": "Tél. différent",
  "taches.propertyA": "Bien A",
  "taches.propertyB": "Bien B",
  "taches.untitled": "Sans titre",
  "taches.price": "Prix",
  "taches.surface": "Surface",
  "taches.rooms": "Pièces",
  "taches.postalCode": "Code postal",
  "taches.phone": "Téléphone",
  "taches.photosA": "Photos A",
  "taches.photosB": "Photos B",
  "taches.rejecting": "Rejet...",
  "taches.reject": "Rejeter",
  "taches.merging": "Fusion...",
  "taches.merge": "Fusionner",
  "taches.matchConfirmed": "Correspondance confirmée",
  "taches.matchSeparated": "Correspondance dissociée",
  "taches.matchScore": "Score de correspondance : {score}",
  "taches.property": "Bien",
  "taches.listing": "Annonce ({source})",
  "taches.separating": "Dissociation...",
  "taches.separate": "Dissocier",
  "taches.confirming": "Confirmation...",
  "taches.confirm": "Confirmer",
  "taches.vacationBanner": "En congés — file en lecture seule. Les actions sont désactivées.",
  "taches.allDone": "Tout est à jour !",
  "taches.noTasks": "Aucune tâche en attente.",
  "taches.duplicate": "Doublon — score {score}",
  "taches.next": "Suivant",

  // ── Validated (valides) ──────────────────────────────────────────────
  "valides.title": "Biens validés",
  "valides.count": "{count} bien(s)",
  "valides.empty": "Aucun bien validé pour le moment.",
  "valides.property": "Bien",
  "valides.price": "Prix",
  "valides.surface": "Surface",
  "valides.city": "Ville",
  "valides.validatedOn": "Validé le",
  "valides.notes": "Notes",
  "valides.notesSaved": "Notes enregistrées",
  "valides.notesFailed": "Échec de l'enregistrement",
  "valides.notesPlaceholder": "Notes...",
  "valides.saving": "Enreg...",
  "valides.untitled": "Sans titre",
  "valides.actions": "Actions",
  "valides.edit": "Modifier",
  "valides.archiveOne": "Archiver ce bien",
  "valides.archiveSelected": "Archiver {count} bien(s)",
  "valides.archiveConfirm": "Archiver {count} bien(s) ? Ils ne seront plus dans les validés mais restent visibles dans les archives.",
  "valides.archived": "{count} bien(s) archivé(s)",
  "valides.archiveFailed": "Échec de l'archivage",
  "valides.editTitle": "Modifier le bien",
  "valides.updated": "Bien mis à jour",
  "valides.updateFailed": "Échec de la mise à jour",
  "valides.save": "Enregistrer",
  "valides.cancel": "Annuler",
  "valides.rooms": "Pièces",
  "valides.bedrooms": "Chambres",
  "valides.postalCode": "Code postal",
  "valides.phone": "Téléphone",

  // ── Comments thread ──────────────────────────────────────────────────
  "comments.title": "Suivi & observations",
  "comments.loading": "Chargement...",
  "comments.empty": "Aucun commentaire pour l'instant.",
  "comments.placeholder": "Ajouter une observation (appel effectué, remarque, prochaine étape…)",
  "comments.add": "Ajouter",
  "comments.saving": "Enreg...",
  "comments.edit": "Modifier",
  "comments.delete": "Supprimer",
  "comments.deleteConfirm": "Supprimer ce commentaire ?",
  "comments.systemAuthor": "Système (import)",
  "comments.addFailed": "Échec de l'ajout du commentaire",
  "comments.updateFailed": "Échec de la modification",
  "comments.deleteFailed": "Échec de la suppression",

  // ── Archives ─────────────────────────────────────────────────────────
  "archives.title": "Archives",
  "archives.count": "{count} bien(s)",
  "archives.all": "Tous",
  "archives.descAll": "Tous les biens archivés",
  "archives.descNegative": "Refus détecté automatiquement par l'IA",
  "archives.descInactivity": "Aucune activité depuis 2 mois (automatique)",
  "archives.descManual": "Archivé manuellement par un commercial",
  "archives.empty": "Aucun bien archivé trouvé.",
  "archives.property": "Bien",
  "archives.price": "Prix",
  "archives.surface": "Surface",
  "archives.city": "Ville",
  "archives.reason": "Raison",
  "archives.archivedOn": "Archivé le",
  "archives.untitled": "Sans titre",

  // ── Manager dashboard ────────────────────────────────────────────────
  "manager.title": "Tableau de bord manager",
  "manager.alertCount": "{count} commercial{s} nécessite attention",
  "manager.period": "Période :",
  "manager.7days": "7j",
  "manager.30days": "30j",
  "manager.loading": "Chargement...",
  "manager.noCommercials": "Aucun commercial trouvé.",
  "manager.commercial": "Commercial",
  "manager.dept": "Dépt.",
  "manager.status": "Statut",
  "manager.manualMessages": "Msg. manuels",
  "manager.fnPending": "FN en att.",
  "manager.scraped": "Scrapés ({period})",
  "manager.smsSent": "SMS ({period})",
  "manager.statusUpdates": "MàJ statut ({period})",
  "manager.validated": "Validés",
  "manager.transformRate": "Tx. transf.",
  "manager.lastActivity": "Dernière activité",
  "manager.vacation": "Congés",
  "manager.alertActive": "Alerte active",
  "manager.onVacation": "En congés",
  "manager.active": "Actif",
  "manager.since": "depuis {date}",
  "manager.daysAgo": "il y a {count}j",
  "manager.never": "jamais",
  "manager.resume": "Reprendre",
  "manager.setVacation": "Mettre en congés",
  "manager.alertLegend": "Alerte active (tâche en retard >7j ou inactivité >7j)",
  "manager.vacationLegend": "Alertes supprimées si commercial en congés",
  "manager.fetchError": "Erreur {status}",
  "manager.unknownError": "Erreur inconnue",
  "manager.toggleError": "Erreur lors du toggle",
  "manager.staleCount": "5j+ sans réponse",
  "manager.totalSent": "Envoyés",
  "manager.totalReplied": "Réponses",
  "manager.responseRate": "Taux réponse",

  // ── Outreach confirm dialog ───────────────────────────────────────────
  "outreach.regenerateConfirm": "Regénérer {count} messages ? Cela lancera {count} appels OpenAI.",

  // ── Property detail errors ────────────────────────────────────────────
  "detail.loadError": "Impossible de charger le bien",
  "detail.unknownError": "Erreur inconnue",
};

export default fr;
